import { SortOrder } from 'kentico-cloud-delivery';

import Client from 'services/kenticoClient';
import { KENTICO_TYPES } from 'common/consts/kentico';

const LIMIT_EVENTS = 3;

class EventsService {
  async fetchEvents() {
    const todayDate = new Date().toISOString().slice(0, 10);

    return Client.items()
      .type(KENTICO_TYPES.EVENT)
      .limitParameter(LIMIT_EVENTS)
      .greaterThanOrEqualFilter('elements.data', todayDate)
      .orderParameter('elements.data', SortOrder.asc)
      .toPromise();
  }
}

export default new EventsService();



// WEBPACK FOOTER //
// ./src/services/Events.service.js